import { render } from "./InspectionPlan.vue?vue&type=template&id=c06ec216"
import script from "./InspectionPlan.vue?vue&type=script&lang=js"
export * from "./InspectionPlan.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__